import { Factory } from '..'
import { Price } from './price-cap'
import {
  applyEntitySchema,
  objectSchema,
  openUnion,
  optionalTolerant,
  parseEntity,
  sourceJson,
} from '../../_utils/fcdc-v2'
import * as z from 'zod'

export class UnlockPrice {
  type: UnlockPriceType
  price: Price

  constructor(json: any) {
    const source = sourceJson(json) as Record<string, unknown>
    const price = sourceJson(source['price'])
    const plain: Record<string, unknown> = { ...source, price }
    this.type = plain['type'] as UnlockPriceType
    this.price = new Price(price)
    applyEntitySchema(this, UnlockPriceSchema, plain, {})
  }

  static getFactory(): Factory<UnlockPrice> {
    return new (class implements Factory<UnlockPrice> {
      make(json: any): UnlockPrice {
        if (json?.type === UnlockPriceType.Limited && typeof json?.count === 'number') {
          return new UnlockPriceLimited(json)
        }
        if (json?.type === UnlockPriceType.Unlimited && json?.price) {
          return new UnlockPriceUnlimited(json)
        }
        return parseEntity(UnlockPriceSchema, json ?? {}) as UnlockPrice
      }
      getTableName(): string {
        throw new Error(
          'getTableName() should never be called on a UnlockPrice. UnlockPrice are not stored in IndexDB.'
        )
      }
    })()
  }
}

export class UnlockPriceLimited extends UnlockPrice {
  count: number

  constructor(json: any) {
    super(json)
    this.count = json.count
  }
}

export class UnlockPriceUnlimited extends UnlockPrice {
  constructor(json: any) {
    super(json)
  }
}

export enum UnlockPriceType {
  Limited = 'Limited',
  Unlimited = 'Unlimited',
}

const UnlockPriceSchema = openUnion('type', {
  [UnlockPriceType.Limited]: objectSchema({
    type: z.literal(UnlockPriceType.Limited),
    count: optionalTolerant(z.number()),
    price: optionalTolerant(z.unknown()),
  }),
  [UnlockPriceType.Unlimited]: objectSchema({
    type: z.literal(UnlockPriceType.Unlimited),
    price: optionalTolerant(z.unknown()),
  }),
})
